import React, { memo } from 'react';
import StyledFieldInfo from './StyledFieldInfo';
import * as GStyled from '../../../styles/components';
import { ReportField } from '../../../models/reportField';
import StyledFieldInfoTitle from './StyledFieldInfoTitle';
import { Icon } from '../../../components';
import { useIsFrs102Enabled } from '../../../util/hooks/useIsFrs102Enabled';
import { replaceIfrsLabels } from '../../../util/frs102Helper';

interface FieldInfoProps {
  isAddedFavorite?: boolean;
  field: ReportField;
}

function FieldInfo({ isAddedFavorite, field }: FieldInfoProps): JSX.Element {
  const isFrs102Enabled = useIsFrs102Enabled();

  return (
    <StyledFieldInfo>
      <StyledFieldInfoTitle>
        {isAddedFavorite && (
          <Icon name="filledStar" width="1.6rem" height="1.6rem" />
        )}
        {replaceIfrsLabels(field.fieldName, isFrs102Enabled)}
      </StyledFieldInfoTitle>
      <GStyled.Text as="div" size="sm">
        {replaceIfrsLabels(field.description, isFrs102Enabled)}
      </GStyled.Text>
    </StyledFieldInfo>
  );
}

export default memo(FieldInfo);
